module.exports = __webpack_public_path__ + "static/media/scale-circle.3de00b04.less";